import { render, staticRenderFns } from "./ConfirmationsPage.vue?vue&type=template&id=c07e64a2&scoped=true"
import script from "./ConfirmationsPage.vue?vue&type=script&lang=js"
export * from "./ConfirmationsPage.vue?vue&type=script&lang=js"
import style0 from "./ConfirmationsPage.vue?vue&type=style&index=0&id=c07e64a2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c07e64a2",
  null
  
)

export default component.exports